<template>
  <div class="space-y-4">
    <div>
      <label class="block text-sm font-medium text-gray-700 mb-2">Title</label>
      <input v-model="localSection.content.title" type="text" class="w-full px-3 py-2 border border-gray-300 rounded-lg" @input="emitUpdate">
    </div>
    <div>
      <label class="block text-sm font-medium text-gray-700 mb-2">Subtitle</label>
      <textarea v-model="localSection.content.subtitle" rows="2" class="w-full px-3 py-2 border border-gray-300 rounded-lg" @input="emitUpdate" />
    </div>
    <div>
      <label class="block text-sm font-medium text-gray-700 mb-2">Button Text</label>
      <input v-model="localSection.content.ctaText" type="text" class="w-full px-3 py-2 border border-gray-300 rounded-lg" @input="emitUpdate">
    </div>
    <div>
      <label class="block text-sm font-medium text-gray-700 mb-2">Button Link</label>
      <input v-model="localSection.content.ctaLink" type="text" class="w-full px-3 py-2 border border-gray-300 rounded-lg" @input="emitUpdate">
    </div>
    <div>
      <label class="block text-sm font-medium text-gray-700 mb-2">Text Color</label>
      <input v-model="localSection.styles.textColor" type="color" class="w-12 h-10 border border-gray-300 rounded cursor-pointer" @input="emitUpdate">
    </div>
    <section-style-fields :section="localSection" @update="applyStyles" />
  </div>
</template>

<script>
import SectionStyleFields from './SectionStyleFields.vue'

export default {
  components: { SectionStyleFields },
  props: { section: { type: Object, required: true } },
  emits: ['update'],
  data() {
    return { localSection: JSON.parse(JSON.stringify(this.section)) }
  },
  watch: {
    section: {
      handler(value) { this.localSection = JSON.parse(JSON.stringify(value)) },
      deep: true,
    },
  },
  methods: {
    emitUpdate() { this.$emit('update', JSON.parse(JSON.stringify(this.localSection))) },
    applyStyles(section) { this.localSection = section; this.emitUpdate() },
  },
}
</script>
